import { Stack } from "@mui/material";
import React from "react";
import { FaInfinity } from "react-icons/fa6";

const Introduction = () => {
  return (
    <Stack
      sx={{
        //border: "1px solid red",
        marginBottom: {
          xs: "20px",
          sm: "20px",
          md: "20px",
          lg: "20px",
          xl: "60px",
        },
      }}
    >
      <Stack
        sx={{
          width: "100%",
          fontSize: {
            xs: "22px",
            sm: "26px",
            md: "30px",
            lg: "34px",
          },
          color: "#054E91",
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 600,
          letterSpacing: "0.5px",
          textAlign: "left",
          marginBottom: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            lg: "20px",
            xl: "20px",
          },
          marginTop: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            lg: "64px",
            xl: "64px",
          },
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: { xl: "6px", lg: "6px", xs: "4px" },
              height: { xs: "22px", sm: "36px", md: "30px" },
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              border: "1px solid rgb(5 78 146)",
              backgroundColor: "rgb(5 78 146)",
              marginRight: {
                xs: "8px",
                sm: "8px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },
              borderTopRightRadius: "8px",
              borderBottomRightRadius: "8px",
            }}
          >
            <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
          </Stack>
        </Stack>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            fontSize: "inherit",
          }}
        >
          Why WhatsApp?
        </span>
      </Stack>

      <Stack
        sx={{
          width: "100%",
          fontSize: {
            xs: "15px",
            sm: "17px",
            md: "20px",
          },
          lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
           fontFamily: "'Roboto', sans-serif",
          color: "text.secondary",
          textAlign: "left",
          border: "1px solid white",
          backgroundColor: "#dae9f8;",
          // padding: "20px",
          padding: 1,
          borderRadius: "8px",
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
        }}
      >
        WhatsApp lets you automate, engage and convert on a trusted, real-time
        messaging platform. With interactive templates, product catalogs,
        in-chat payments, rich media flows and verified business messaging, it
        enables secure, personalized communication and end-to-end workflow
        automation across every stage of the customer journey.
      </Stack>

      {/* Mobile Paragraph */}
      <Stack
        sx={{
          width: "100%",
          fontFamily: "'Roboto', sans-serif",
          fontSize: {
            xs: "16px",
            sm: "16px",
            md: "16px",
            lg: "24px",
            xl: "24px",
          },
          lineHeight: {
            xs: "24px",
            sm: "28px",
            md: "32px",
            lg: "32px",
            xl: "32px",
          },
          fontWeight: 400,
          display: {
            xl: "none",
            lg: "none",
            md: "none",
            sm: "none",
            xs: "flex",
          },
          color: "#333",
          textAlign: "left",
          border: "1px solid rgb(218 233 248)",
          padding: 1,
          borderRadius: "8px",
          // backgroundColor: "rgb(218 233 248)",
          backgroundColor: "white",
          marginBottom: { xl: "0px", lg: "40px", md: "20px" },
        }}
      >
        <span>
          WhatsApp enables direct, personal communication with customers,
          enhancing engagement and driving conversions.
        </span>
      </Stack>
    </Stack>
  );
};

export default Introduction;
